Vue.component("course_ppt_panel", {
  props: {
    live_id: {
      type: String,
      default: ''
    },
    allow_download: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      currentFile: {},
      dialogVisible: false
    }
  },
  // mounted() {
  //   this.getData()
  // },
  watch: {
    live_id: {
      handler(newVal) {
        if (newVal) this.getData()
      },
      immediate: true
    }
  },
  methods: {
    getData() {
      API.reqLivePpt({ _id: this.live_id }).then(res => {
        // console.log('ppt', res)
        if (res.error_code != 'livemanage.0000.0000') return
        let files = res.extend_message.course_wares || []
        if (!files.length) return
        this.$emit('show')
        this.fileList = files
        this.pptPreviewInit(files[0])
      })
    },
    pptPreviewInit(file) {
      const filepath = file.file_path;
      const filename = decodeURIComponent(common.getFileNameByPath(file.file_path));
      const fileType = common.getFileTypeByPath(file.file_path);
      const key = Date.now().toString();
      const documentType = common.getDocumentType(fileType);
      const url = filepath.includes("http") ? filepath : location.origin + filepath;
      const config = {
        document: {
          fileType,
          key,
          title: filename,
          url
        },
        documentType,
        height: "100%",
        type: "embedded",//desktop mobile embedded
        width: "100%",
        lang: "zh-cn",
        editorConfig: {
          // "coEditing": {
          //     "mode": "fast",
          //     "change": true
          // },
          lang: "zh-cn",
          region: "zh-CN",
          location: "cn",
          mode: "view",//view edit
          user: {
            // "group": "Group1",
            id: this.loginUserInfo ? this.loginUserInfo.user_code : 'youke',
            name: this.loginUserInfo ? this.loginUserInfo.nick_name : '游客'
          },
          // "plugins": {},
          customization: {
            help: false,
            hideNotes: true,
            comments: false,
            chat: false,
            integrationMode: "embed",
            logo: {
              image: "/documentserver/web-apps/apps/common/main/resources/img/header/header-logo_s.png",
              imageDark: "/documentserver/web-apps/apps/common/main/resources/img/header/dark-logo_s.png",
              url: "http://www.sobey.com"
            },
            // uiTheme: "theme-classic-light",//theme-light, theme-classic-light, theme-dark, theme-contrast-dark default-dark, default-light default:theme-classic-light
            toolbarNoTabs: true,
            toolbarHideFileName: true,
            review: {
              hideReviewDisplay: false,
              showReviewChanges: false,
              reviewDisplay: false,
              trackChanges: false,
              hoverMode: false
            },
          },
        },
      }
      config.token = common.jwtSign(config, "tUVvbKk2mX4T40MBRrtj");
      console.log('config', config)
      this.$nextTick(() => {
        setTimeout(() => {
          new DocsAPI.DocEditor('ppt_container', config);
        }, 2000)
      })
    },
    handlePpt(item) {
      console.log(item)
      this.currentFile = item
      this.dialogVisible = true
      const file_path = item.file_path;
      const filename = decodeURIComponent(common.getFileNameByPath(file_path));
      const fileType = common.getFileTypeByPath(file_path);
      const key = Date.now().toString();
      const documentType = common.getDocumentType(fileType);
      const url = file_path.includes("http") ? file_path : location.origin + file_path;
      const config = {
        document: {
          fileType,
          key,
          title: filename,
          url
        },
        documentType,
        height: "100%",
        type: "desktop",//desktop mobile embedded
        width: "100%",
        lang: "zh-cn",
        editorConfig: {
          // "coEditing": {
          //     "mode": "fast",
          //     "change": true
          // },
          lang: "zh-cn",
          region: "zh-CN",
          location: "cn",
          mode: "view",//view edit
          user: {
            // "group": "Group1",
            id: this.loginUserInfo ? this.loginUserInfo.user_code : 'youke',
            name: this.loginUserInfo ? this.loginUserInfo.nick_name : '游客'
          },
          // "plugins": {},
          customization: {
            help: false,
            hideNotes: true,
            comments: true,
            chat: false,
            integrationMode: "embed",
            logo: {
              image: "/documentserver/web-apps/apps/common/main/resources/img/header/header-logo_s.png",
              imageDark: "/documentserver/web-apps/apps/common/main/resources/img/header/dark-logo_s.png",
              url: "http://www.sobey.com"
            },
            uiTheme: "theme-classic-light",//theme-light, theme-classic-light, theme-dark, theme-contrast-dark default-dark, default-light default:theme-classic-light
          }
        },
      }
      config.token = common.jwtSign(config, "tUVvbKk2mX4T40MBRrtj");
      this.$nextTick(() => {
        setTimeout(() => {
          new DocsAPI.DocEditor("ppt_container_1", config);
        }, 2000)
      })
    },
    handleDownload() {
      for (let i = 0; i < this.fileList.length; i++) {
        let a = document.createElement('a')
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = this.fileList[i].file_name; // 设置图片名称
        a.href = this.fileList[i].file_path; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
        a.remove();
      }
    }
  },
  template: `
    <div class="course_ppt_container">
      <el-button class="download_btn" type="primary" @click="handleDownload" size="small" :disabled="!allow_download"><iconfont type="iconxiazai3"></iconfont>下载课件</el-button>
      <el-dialog :title="currentFile.file_name" :visible.sync="dialogVisible" custom-class="ppt_dialog">
        <div class="ppt_container_1"><div id="ppt_container_1"></div></div>
      </el-dialog>
      <div class="item" v-for="item in fileList" @click.prevent="handlePpt(item)">
        <div>{{item.file_name}}</div>
        <div class="ppt_container" v-if="fileList.length == 1"><div id="ppt_container"></div></div>
      </div>
    </div>
  `,
});